import { Eye, EyeOff, CheckSquare, Square, Radio } from 'lucide-react'
import { liveStatusLabel, liveStatusClass } from '../../../utils/liveStatus'

export default function CatalogList({
  items,
  loading,
  selected,
  checked,
  onSelect,
  onToggle,
  onToggleAll
}) {
  if (loading && items.length === 0) {
    return <div className="catalog-list-empty">Loading...</div>
  }

  if (items.length === 0) {
    return <div className="catalog-list-empty">No items found</div>
  }

  const allChecked = items.length > 0 && items.every(item => checked.has(item.tbtv_id))
  const someChecked = checked.size > 0

  return (
    <div className="catalog-list">
      <div className="catalog-list-header">
        <label className="select-all" onClick={() => onToggleAll(items)}>
          {allChecked ? <CheckSquare size={16} /> : <Square size={16} />}
          <span>Select all</span>
        </label>
      </div>

      <div className="catalog-list-items">
        {items.map(item => {
          const isSelected = selected?.tbtv_id === item.tbtv_id
          const isChecked = checked.has(item.tbtv_id)

          return (
            <div
              key={item.tbtv_id}
              className={`catalog-list-item ${isSelected ? 'selected' : ''} ${isChecked ? 'checked' : ''}`}
            >
              <div className="item-checkbox" onClick={e => { e.stopPropagation(); onToggle(item.tbtv_id) }}>
                {isChecked ? <CheckSquare size={16} /> : <Square size={16} />}
              </div>
              
              <div className="item-content" onClick={() => onSelect(item)}>
                <div className="item-thumb">
                  {item.thumbnail_url ? (
                    <img src={item.thumbnail_url} alt="" />
                  ) : (
                    <div className="thumb-placeholder" />
                  )}
                </div>
                
                <div className="item-info">
                  <div className="item-title">{item.title || 'Untitled'}</div>
                  <div className="item-meta">
                    <span className={`status-badge ${item.status}`}>
                      {item.status === 'active' ? <Eye size={10} /> : <EyeOff size={10} />}
                      {item.status}
                    </span>
                    {item.event_mode === 'live' && (
                      <span className={`event-mode-badge live ${liveStatusClass(item.live_v2_status, item.event_type)}`}>
                        {liveStatusLabel(item.live_v2_status, item.event_type)}
                      </span>
                    )}
                    {item.event_mode === 'live' && item.youtube_simulcast_mode === 'simulcast' && (
                      <span className="yt-simulcast-badge" title={`Simulcasting to YouTube${item.youtube_privacy ? ` (${item.youtube_privacy})` : ''}`}>
                        <Radio size={10} /> YT
                      </span>
                    )}
                    {item.release_date && (
                      <span className="item-date">{item.release_date}</span>
                    )}
                  </div>
                  {item.tags && item.tags.length > 0 && (
                    <div className="item-tags">
                      {item.tags.slice(0, 3).map(t => (
                        <span key={t} className="tag-chip-mini">{t}</span>
                      ))}
                      {item.tags.length > 3 && (
                        <span className="tag-chip-mini more">+{item.tags.length - 3}</span>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
